'use client'

import Breadcrumbs from '@/components/ui/Breadcrumbs'
import { useState } from 'react'
import { FaPlus, FaMinus } from 'react-icons/fa'
import { motion, AnimatePresence } from 'framer-motion'

export const DeliveryClient = () => {
    const [openMoscow, setOpenMoscow] = useState(false)
    const [openRussia, setOpenRussia] = useState(false)
    return (
        <section className="max-w-7xl mx-auto px-4 py-10">
            <div className="grid grid-cols-1 lg:grid-cols-[1fr_360px] gap-4 md:gap-10">
                <div>
                    <Breadcrumbs />
                    <h1 className="mb-4">Доставка</h1>

                    <p className="text-sm text-gray-700 leading-relaxed mb-8">
                        Мы осуществляем доставку по Москве и Московской области
                        в пределах 50 км нашими автомобилями. Доставка по всей
                        России осуществляется через транспортные компании. Мы
                        работаем с большим количеством ТК. Подробная информация
                        по доставке ниже. Если вы не нашли свою транспортную
                        компанию, уточните у менеджера возможность отправки той
                        компанией, которой хотели.
                    </p>

                    <div className="border-t border-b py-4">
                        <button
                            onClick={() => setOpenMoscow(!openMoscow)}
                            className="w-full flex justify-between items-center text-left"
                        >
                            <span className="font-semibold text-second">
                                Стоимость доставки по Москве и области
                            </span>
                            <span className="text-xl">
                                {openMoscow ? (
                                    <FaMinus size={16} />
                                ) : (
                                    <FaPlus size={16} />
                                )}
                            </span>
                        </button>

                        <AnimatePresence initial={false}>
                            {openMoscow && (
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: 'auto', opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{
                                        duration: 0.25,
                                        ease: 'easeInOut',
                                    }}
                                    className="overflow-hidden"
                                >
                                    <div className="mt-6 text-sm">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3">
                                            <div>
                                                Доставка по Москве в пределах
                                                МКАД при заказе до 30 000 ₽
                                            </div>
                                            <div className="md:text-right font-bold">
                                                700 ₽
                                            </div>

                                            <div>
                                                Доставка по Москве в пределах
                                                МКАД при заказе свыше 30 000 ₽
                                            </div>
                                            <div className="md:text-right font-bold">
                                                Бесплатно
                                            </div>

                                            <div>
                                                Доставка за МКАД в пределах 5–15
                                                км от МКАД
                                            </div>
                                            <div className="md:text-right font-bold">
                                                1 200 ₽
                                            </div>

                                            <div>
                                                Доставка за МКАД в пределах
                                                15–30 км от МКАД
                                            </div>
                                            <div className="md:text-right font-bold">
                                                1 500 ₽
                                            </div>

                                            <div>
                                                Доставка за МКАД в пределах
                                                30–50 км от МКАД
                                            </div>
                                            <div className="md:text-right font-bold">
                                                2 000 ₽
                                            </div>

                                            <div>
                                                Доставка за МКАД до 50 км при
                                                заказе свыше 55 000 ₽
                                            </div>
                                            <div className="md:text-right font-bold">
                                                Бесплатно
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="border-b py-4">
                        <button
                            onClick={() => setOpenRussia(!openRussia)}
                            className="w-full flex justify-between items-center text-left"
                        >
                            <span className="font-semibold text-second">
                                Доставка по России и СНГ
                            </span>
                            <span className="text-xl">
                                {openRussia ? (
                                    <FaMinus size={16} />
                                ) : (
                                    <FaPlus size={16} />
                                )}
                            </span>
                        </button>
                        <AnimatePresence initial={false}>
                            {openRussia && (
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: 'auto', opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{
                                        duration: 0.25,
                                        ease: 'easeInOut',
                                    }}
                                    className="overflow-hidden"
                                >
                                    <div className="mt-6 text-sm  space-y-4 leading-relaxed">
                                        <p>
                                            Мы осуществляем доставку товара по
                                            всей России через транспортные
                                            компании и курьерские службы
                                            доставки.
                                        </p>

                                        <p>
                                            Точную стоимость доставки вы можете
                                            уточнить у менеджера, так как каждый
                                            заказ рассчитывается индивидуально в
                                            зависимости от объема, веса, региона
                                            и места доставки.
                                        </p>

                                        <p>
                                            При сумме заказа{' '}
                                            <strong>свыше 30 000 ₽</strong>{' '}
                                            доставка до транспортной компании
                                            осуществляется{' '}
                                            <strong>БЕСПЛАТНО</strong>.
                                        </p>

                                        <p>
                                            При сумме заказа{' '}
                                            <strong>менее 30 000 ₽</strong> мы
                                            доставим ваш товар до одной из
                                            транспортных компаний:
                                        </p>

                                        <ul className="space-y-1 font-bold">
                                            <li>Деловые линии — 300 ₽</li>
                                            <li>Байкал Сервис — 600 ₽</li>
                                            <li>ЖелДорЭкспедиция — 600 ₽</li>
                                            <li>ПЭК — 300 ₽</li>
                                        </ul>

                                        <p>
                                            Представленные транспортные компании
                                            — это перевозчики, с которыми мы
                                            работаем уже очень давно. По
                                            согласованию с клиентом возможна
                                            доставка до других транспортных
                                            компаний.
                                        </p>
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <p className="text-sm text-gray-700 leading-relaxed mt-8">
                        Так же, после подтверждения менеджера о комплектации
                        вашего заказа, вы всегда можете забрать товар
                        самовывозом с нашего склада по адресу:
                        <strong> м. Люблино </strong>
                    </p>
                </div>

                <aside className="lg:sticky lg:top-24 h-fit sm:border sm:rounded-lg py-4 sm:p-6">
                    <h2 className="text-xl font-semibold mb-6">
                        Наши контакты
                    </h2>

                    <div className="space-y-6 text-sm">
                        <div>
                            <p className="font-semibold  mb-1">Почта</p>
                            <p className="text-gray-600">
                                Оставьте отзыв или задайте вопрос
                            </p>
                            <a
                                href="mailto:snab@marketsiz.ru"
                                className="text-warning font-bold hover:underline"
                            >
                                snab@marketsiz.ru
                            </a>
                        </div>

                        <div>
                            <p className="font-semibold mb-1">
                                Пункты выдачи заказа
                            </p>
                            <p className="text-gray-600">
                                <strong>г. Москва</strong>
                                <br />
                                ул. Краснодонская д.2. к.1 м. Волжская
                            </p>
                        </div>

                        <div>
                            <p className="font-semibold  mb-1">Телефон</p>
                            <p className="text-gray-600">
                                Пн–Пт с 09:00 до 18:00 (МСК)
                            </p>
                            <a
                                href="tel:+79162015339"
                                className="text-warning font-bold hover:underline"
                            >
                                +7 916 201 53 39
                            </a>
                        </div>
                    </div>
                </aside>
            </div>
        </section>
    )
}
